import React, { Component } from "react";
import DigitalSidebar from "./DigitalSidebar";
import Banner from "../../components/common/Banner";
import Header from "../../components/common/Header";
import Footer from "../../components/common/Footer";

export default class ItInfrastructure extends Component {
  render() {
    return (
      <div>
        {/* Header */}
        <Header />

        {/* Banner */}
        <Banner title="Digital Library" image="banner/library-3.jpg" />

        {/* Content */}
        <div className="sidebar ttm-sidebar ttm-bgcolor-white clearfix">
          <div className="container-xl">
            <div className="row">
              <div className="col-lg-9 content-area order-lg-2">
                <div className="ttm-service-single-content-area">
                  <div className="section-title with-desc text-left clearfix">
                    <div
                      className="title-header"
                      style={{ borderTopColor: "red" }}
                    >
                      <h4 className="title">Hardware</h4>
                    </div>
                  </div>
                  <table class="table">
                    <thead
                      style={{ backgroundColor: "#98002e", color: "white" }}
                    >
                      <tr>
                        <th scope="col">SL No</th>
                        <th scope="col">Hardware Description</th>
                        <th scope="col">Qty</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>01</td>
                        <td>Servers</td>
                        <td>02</td>
                      </tr>
                      <tr>
                        <td>02</td>
                        <td>Network Switches</td>
                        <td>35</td>
                      </tr>
                      <tr>
                        <td>03</td>
                        <td>Computer Systems</td>
                        <td>35</td>
                      </tr>
                      <tr>
                        <td>04</td>
                        <td>UPS</td>
                        <td>02</td>
                      </tr>
                      <tr>
                        <td>05</td>
                        <td>Print/Copy/ Scanner</td>
                        <td>03</td>
                      </tr>
                      <tr>
                        <td>06</td>
                        <td>Barcode Printer /scanners</td>
                        <td>01/08</td>
                      </tr>
                      <tr>
                        <td>07</td>
                        <td>Headphones</td>
                        <td>10</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div className="ttm-service-single-content-area paddingtop-2">
                  <div className="section-title with-desc text-left clearfix">
                    <div
                      className="title-header"
                      style={{ borderTopColor: "red" }}
                    >
                      <h4 className="title">Software</h4>
                    </div>
                  </div>
                  <table class="table">
                    <thead
                      style={{ backgroundColor: "#98002e", color: "white" }}
                    >
                      <tr>
                        <th scope="col">SL No</th>
                        <th scope="col">Software Description</th>
                        <th scope="col">Version</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>01</td>
                        <td>Operating System</td>
                        <td>Windows</td>
                      </tr>
                      <tr>
                        <td>02</td>
                        <td>Library Automation Software</td>
                        <td>Libsoft 12.0.0</td>
                      </tr>
                      <tr>
                        <td>03</td>
                        <td>Plagiarism Checking Tool</td>
                        <td>DrillBit</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div className="ttm-service-single-content-area paddingtop-2">
                  <div className="section-title with-desc text-left clearfix">
                    <div
                      className="title-header"
                      style={{ borderTopColor: "red" }}
                    >
                      <h4 className="title">IT Infrastructure</h4>
                    </div>
                  </div>
                  <table class="table">
                    <thead
                      style={{ backgroundColor: "#98002e", color: "white" }}
                    >
                      <tr>
                        <th scope="col">SL No</th>
                        <th scope="col">IT Infrastructure Description</th>
                        <th scope="col"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>01</td>
                        <td>Internet Bandwidth (Overall Campus)</td>
                        <td>750 Mbps</td>
                      </tr>
                      <tr>
                        <td>02</td>
                        <td>Wi-Fi Access</td>
                        <td>Enabled</td>
                      </tr>
                      <tr>
                        <td>03</td>
                        <td>Fort iGATE firewall</td>
                        <td>Enabled</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div className="ttm-service-single-content-area paddingtop-2">
                  <div className="section-title with-desc text-left clearfix">
                    <div
                      className="title-header"
                      style={{ borderTopColor: "red" }}
                    >
                      <h4 className="title">Software Information</h4>
                    </div>
                  </div>
                  <table class="table">
                    <thead
                      style={{ backgroundColor: "#98002e", color: "white" }}
                    >
                      <tr>
                        <th scope="col">SL No</th>
                        <th scope="col">Server Name</th>
                        <th scope="col">Role</th>
                        <th scope="col">Services</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>01</td>
                        <td>Libsoft Server</td>
                        <td>
                          Integrated multiuser Library management software,
                          powerful and user-friendly. WEB-OPAC Performing Daily
                          Application BACKUP
                        </td>
                        <td>
                          Mails sent to every user transactions communicating
                          through server.
                        </td>
                      </tr>
                      <tr>
                        <td>02</td>
                        <td>NPTEL Server</td>
                        <td>Data connection between client and server</td>
                        <td>Providing IIT and IISc Lecture videos.</td>
                      </tr>
                      <tr>
                        <td>03</td>
                        <td>Access Control Server</td>
                        <td>GATE Entry to Access Library</td>
                        <td>User statistics and reports.</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="col-lg-3 widget-area">
                <DigitalSidebar />
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <Footer />
      </div>
    );
  }
}
